import React from 'react';

import BackgroundImage from '../BackgroundImage/index.jsx';

import BEM from '../../Utilities/BEM/index.jsx';


class NotificationImage extends React.Component {
  render() {
    var image = this.props.image;

    return (
      <div className={BEM.classString("cs-notification-image", this.props.variant)}>
        <BackgroundImage image={image} variant="square" />
      </div>
    );
  }
}


export default NotificationImage;

